var all_products = $('#product-grid li').length;
    var rem_products = all_products%3;
    if(rem_products>0){
        for(var i = rem_products; i > 0; i--){
            // $(`#product-grid li:nth-last-child(${i})`).hide();
        }
    }
var products_on_page = $('.products-on-page');
var next_url = products_on_page.data('next-url');
var load_more_btn = $('.load-more-btn');
var load_more_spinner = $('.load-more-spinner');
  if(next_url == '')
  {
  	load_more_btn.hide();
  }
function mrkloadmore(){
$.ajax({
    url: next_url,
    type: 'GET',
    dataType : 'html',
  beforeSend(){
	load_more_btn.hide();
    load_more_spinner.show();
}
}

).done(function(next_page){
  console.log(next_page,'next_page');
  	load_more_spinner.hide();
    var new_products = $(next_page).find('.products-on-page');
    var new_url = new_products.data('next-url');
    next_url = new_url;
    $('.products-on-page').attr('data-next-url',next_url);
    products_on_page.append(new_products.html());
    if(window.innerWidth>990)
    $('a.siv-grid-items.active').click();
    $('#product-grid li').show();
    var all_products = $('#product-grid li').length;
    var rem_products = all_products%3;
    if(rem_products>0){
        for(var i = rem_products; i > 0; i--){
            // $(`#product-grid li:nth-last-child(${i})`).hide();
        }
    }
  if(new_url)
  {
  	load_more_btn.show();
  }else{
    $('#product-grid li').show();
  }
})
}